import React, { useMemo } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from "@stripe/react-stripe-js";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Lock } from "lucide-react";

// Cache Stripe instances per publishable key so we never re-init on re-render.
const _stripeCache = {};
function getStripe(pk) {
  if (!pk) return null;
  if (!_stripeCache[pk]) _stripeCache[pk] = loadStripe(pk);
  return _stripeCache[pk];
}

export function EmbeddedCheckoutModal({ open, onClose, clientSecret, publishableKey, title = "Complete your donation" }) {
  const stripePromise = useMemo(() => getStripe(publishableKey), [publishableKey]);

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose?.(); }}>
      <DialogContent
        className="max-h-[92vh] w-[calc(100vw-1.5rem)] max-w-lg overflow-y-auto p-0 sm:max-w-lg"
        data-testid="embedded-checkout-modal"
      >
        <DialogHeader className="border-b border-ff-border px-5 py-4">
          <DialogTitle className="flex items-center gap-2 font-heading text-base font-bold text-ff-blue">
            <Lock className="h-4 w-4 text-ff-green" /> {title}
          </DialogTitle>
          <DialogDescription className="sr-only">Secure Stripe payment form. Your card details are handled directly by Stripe.</DialogDescription>
        </DialogHeader>
        <div className="px-3 py-3 sm:px-4" data-testid="embedded-checkout-mount">
          {stripePromise && clientSecret ? (
            <EmbeddedCheckoutProvider stripe={stripePromise} options={{ clientSecret }}>
              <EmbeddedCheckout />
            </EmbeddedCheckoutProvider>
          ) : (
            <div className="py-10 text-center text-sm text-ff-medium" data-testid="embedded-checkout-loading">
              Loading secure checkout…
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default EmbeddedCheckoutModal;
